import { render } from "./TemplateRetail.vue?vue&type=template&id=28fe7b84"
import script from "./TemplateRetail.vue?vue&type=script&lang=js"
export * from "./TemplateRetail.vue?vue&type=script&lang=js"

import "./TemplateRetail.vue?vue&type=style&index=0&id=28fe7b84&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__